import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const RegisterPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Register
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Register page coming soon...
      </Typography>
    </Container>
  );
};

export default RegisterPage;
